<template>
    <div class="confirm-account">
        <hub-form v-slot:formcontent ref="hubForm" :onSubmit="savePassword">

            <div class="logo">
                <img src="/logo.png" />
                <h2>X-CUBE</h2>
            </div>
            <h3>CONFIRM ACCOUNT</h3>
            <p>
                Enter a password to finish your registration
                and to get access to your locations bookings and settings
            </p>
            <input placeholder="password" type="password" autocomplete="new-password" v-model="model.password"
                maxLength="32" minLength="5" required />
            <input placeholder="confirm password" type="password" autocomplete="new-password"
                v-model="model.confirmPassword" maxLength="32" minLength="5" required />
            <button @submit.prevent>Confirm password</button>
            <router-link to="/login">
                Back to login
            </router-link>
        </hub-form>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { confirmManagedUser } from "../../api/rest";
import MESSAGE_TYPES from "../../constants/messageTypes";
import HubForm from "../shared/Form.vue";
import { Message } from "element-ui";

const router = useRouter();
const route = useRoute();
const hubForm = ref(null);

const token = route.params.token;
const messages = {
    "200-299": {
        text: "Successfully registered account",
        type: MESSAGE_TYPES.success,
    },
    404: {
        text: "Token not found, please contact support.",
        type: MESSAGE_TYPES.error,
    },
    409: {
        text: "Account already confirmed. Please go to login",
        type: MESSAGE_TYPES.error,
    },
    default: {
        text: "Server error please try again later",
        type: MESSAGE_TYPES.error,
    },
};

const model = ref({
    password: "",
    confirmPassword: "",
});

const samePasswords = computed(() => model.value.password === model.value.confirmPassword);

const savePassword = async () => {

    if (!samePasswords.value) {
        Message.error({ message: "Passwords do not match" });
    } else {
        try {
            await confirmManagedUser(token, model.value.password);
            Message.success({ message: "Successfully registered account" });
            router.push({
                name: "login",
            });
        } catch (error) {
            Message.error({ message: error.message });
        }
    }
};
</script>

<style scoped>
.confirm-account {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.container {
    position: relative;
    background-color: black;
    border-radius: 0;
    width: 290px;
    padding: 20px;
    box-shadow: 0 0 20px black;
}

img {
    height: 64px;
}


form:not(.el-form) {
    button {
        margin-top: 24px;
        cursor: pointer;
    }
}
</style>
